import React from 'react';
import { CheckIcon, ClockIcon, CreditCardIcon, ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URL_ESTANDAR } from '../data/content';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
interface FinalCtaProps {
  durationHours: number;
}
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Pago seguro'
}, {
  icon: ClockIcon,
  label: 'Acceso en 5 min'
}, {
  icon: CheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function FinalCta({
  durationHours
}: FinalCtaProps) {
  return <section className="bg-cream-100 px-5 py-12 sm:py-20" data-id="element-69" data-mp="1t2ydkrb0wl96">
      <div className="mx-auto max-w-2xl text-center" data-id="element-70" data-mp="1t2evnaldhwv5">
        <h2 className="font-display text-[1.6rem] leading-tight text-forest-900 sm:text-4xl" style={{
        fontWeight: 700
      }} data-id="element-71" data-mp="1o43hworyj27n">
          No dejes pasar esta oportunidad
        </h2>
        <p className="mt-2.5 text-[0.62rem] font-bold uppercase tracking-[0.18em] text-forest-600 sm:mt-3 sm:text-xs sm:tracking-[0.2em]" data-id="element-72" data-mp="1x4tdpsh7wsld">
          Termina en
        </p>
        <div className="mt-3.5 sm:mt-5" data-id="element-73" data-mp="n7p77h9x5hld">
          <Countdown durationHours={durationHours} tone="light" data-id="element-74" data-mp="s45u685dtpwv" />
        </div>

        <div className="mt-7 rounded-2xl bg-forest-800 p-5 shadow-lift sm:mt-10 sm:p-8" data-id="element-75" data-mp="x3s7sip4h867">
          <h3 className="font-display text-base text-cream-50 sm:text-xl" style={{
          fontWeight: 700
        }} data-id="element-76" data-mp="x64v7bdngaqn">
            Pack Sin Culpa, Sin Destrozos
          </h3>
          <p className="mt-1 text-[0.75rem] text-cream-200 sm:mt-1.5 sm:text-sm" data-id="element-77" data-mp="1646vtpth11de">7 tomos + 5 bonos estratégicos</p>
          <p className="mt-4 flex items-end justify-center gap-2.5 sm:mt-5 sm:gap-3" data-id="element-78" data-mp="1b16zxv6rfu1v">
            <span className="font-display text-base text-cream-200/60 line-through sm:text-lg" data-id="element-79" data-mp="1fwcx5q5m4v59">$49.990</span>
            <span className="font-display text-[2.4rem] leading-none text-gold-400 sm:text-5xl" style={{
            fontWeight: 700
          }} data-id="element-80" data-mp="1kv7dmlg3y7m7">
              $19.990
            </span>
          </p>
          <div className="mt-5 sm:mt-8" data-id="element-81" data-mp="1tropxs07kbjj">
            <CtaButton href={CHECKOUT_URL_ESTANDAR} className="w-full" data-id="element-82" data-mp="3qtvzsk61pgje">
              QUIERO ACCEDER AL PACK
            </CtaButton>
          </div>
          <ul className="mt-3.5 flex flex-wrap justify-center gap-x-3 gap-y-1 text-[0.65rem] font-medium text-cream-200/75 sm:mt-5 sm:gap-x-4 sm:gap-y-1.5 sm:text-[0.7rem]" data-id="element-83" data-mp="3lthpevgz1ui7">
            {trust.map(item => <li key={item.label} className="flex items-center gap-1" data-id="element-84" data-mp="3uu629mumpoti">
                <item.icon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-85" data-mp="dehfnhlln8ja" />
                {item.label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}